import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15.187 6.913a.67.67 0 0 0-.52-.246h-1.334V6a2 2 0 0 0-2-2H7.147l-.214-.667A2 2 0 0 0 5.04 2H2.667a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h9.6a2 2 0 0 0 1.946-1.567l1.12-4.953a.67.67 0 0 0-.146-.567M3.58 12.147a.67.67 0 0 1-.667.52h-.246A.667.667 0 0 1 2 12V4a.667.667 0 0 1 .667-.667H5.04a.67.67 0 0 1 .667.454l.36 1.093a.67.67 0 0 0 .6.453h4.666A.667.667 0 0 1 12 6v.667H5.333a.67.67 0 0 0-.666.52zm9.333 0a.67.67 0 0 1-.666.52h-7.44a1 1 0 0 0 .073-.234L5.867 8h8z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })